import { colorsPalettes } from "@similarweb/styles";

import type { GradientSchema, LineChartColorSchema } from "./types";

export const DEFAULT_LINE_COLORS: Required<LineChartColorSchema> = {
    lineColor: colorsPalettes.blue[400],

    areaEnabled: true,
    areaStop1Color: "rgb(233, 241, 253)",
    areaStop2Color: "rgba(233, 241, 253, 0.2)",
    markerColor: colorsPalettes.blue[400],
    labelColor: "#111827",
    gridLineColor: "#e5e7eb",
    axisLineColor: "#d1d5db",
    tooltipBg: colorsPalettes.carbon[0],
    tooltipText: colorsPalettes.carbon[500],
    tooltipBorder: "#111827",
    background: "transparent",
};

export const gradientDefault: GradientSchema = {
    startColor: "rgb(62, 116, 254, 0.12)",
    endColor: "rgb(62, 116, 254, 0.02)",
};

export const LINE_WIDTH = 2;

export const DEFAULT_DECIMAL = 2;

export const EMPTY_LINE_DATA_CONFIG = [
    { key: "1", value: 100 },
    { key: "2", value: 90 },
    { key: "3", value: 110 },
    { key: "4", value: 120 },
    { key: "5", value: 100 },
    { key: "6", value: 112 },
    { key: "7", value: 89 },
    { key: "8", value: 94 },
];
